export default __webpack_public_path__ + "static/media/m-fsk-15.1dcb25a6.jpg";